import React from 'react'
import Masters_header from './Masters_header'
import { useState, useRef, useEffect } from "react";
import DatePicker from "../DatePicker"
import ReactPaginate from "react-paginate";
import ChargeCode_popup from './ChargeCode_popup';
import Vector from "../../assets/svg/editIcon.svg";
import Delete from "../../assets/svg/DeleteIcon.svg";
import "../../styles/ChargeCode.css";
import { ToastContainer, toast } from "react-toastify";
import { fetchWithAuth } from '../../fetchWithAuth';
import axiosInstance from '../../axiosInstance';
import excel_icon from "../../assets/svg/excel_icon.svg";
import download_arrow from "../../assets/svg/download_arrow.svg";
import plus_circle from "../../assets/svg/plus-circle.svg"
import { FaExclamationCircle } from 'react-icons/fa'; // Font Awesome icon
import { usePermissions } from '../../hooks/PermissionContext';
import PermissionWrapper from '../../hooks/PermissionWrapper';
import AdditionalPermissionWrapper from '../../hooks/AdditionalPermissionWrapper';
import ConfirmDialog from '../../ConfirmDialog/ConfirmDialog';
import CommonFooter from '../../CommonFooter/CommonFooter';


const ChargeCode = () => {

  let ModuleId = 1
  const { getModulePermission } = usePermissions();
  const permission = getModulePermission(ModuleId);
  console.log("activeModuleId", ModuleId);

  const [searchTerm, setSearchTerm] = useState('');
  const [tableData, setTableData] = useState([]);
  const [error, setError] = useState(null);
  const [limit, setLimit] = useState(5);
  const [currentPage, setCurrentPage] = useState(0);
  const [skip, setSkip] = useState(0);
  const [total, setTotal] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const popupRef = useRef(null);
  const [editData, setEditData] = useState(null);
  const [showUploadPopup, setShowUploadPopup] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [isDragging, setIsDragging] = useState(false);
  const fileInputRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [errorData, setErrorData] = useState(null);
  const [confirmDeleteOpen, setConfirmDeleteOpen] = useState(false);
  const [selectedChargeCodeId, setSelectedChargeCodeId] = useState(null);
  const [bulkConfirmOpen, setBulkConfirmOpen] = useState(false);
  const [bulkDeleteIds, setBulkDeleteIds] = useState([]);

  useEffect(() => {
    fetchChargeCodes(searchTerm);
  }, [skip, limit]);


  // const fetchChargeCodes = async () => {
  //   try {
  //     // const response = await fetch(`https://digitallr-uat.flyjaclogistics.com/cost_modelling-be/charge/list?skip=${skip}&limit=${limit}`);
  //     const response = await fetchWithAuth(
  //       `/charge/list?skip=${skip}&limit=${limit}`
  //     );

  //     if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);

  //     const data = await response.json();
  //     console.log("data.......", data);
  //     if (Array.isArray(data.category)) {
  //       setTableData(data.category);
  //       setTotal(data.totalCount || 0);
  //       setTotalPages(Math.ceil((data.totalCount || 0) / limit));
  //     } else {
  //       setTableData([]);
  //     }
  //   } catch (error) {
  //     setError(error.message);
  //     console.error("There was a problem with the fetch operation:", error);
  //   }
  // };

  const fetchChargeCodes = async (term = '') => {
    try {
      const response = await axiosInstance.get(`/charge/list`, {
        params: {
          skip,
          limit,
          search: term || undefined,
        }
      });

      const data = response.data;
      console.log("data.......", data);

      if (Array.isArray(data.category)) {
        setTableData(data.category);
        setTotal(data.totalCount || 0);
        setTotalPages(Math.ceil((data.totalCount || 0) / limit));
      } else {
        setTableData([]);
      }
    } catch (error) {
      setError(error.message);
      console.error("There was a problem with the axios operation:", error);
    }
  };



  // const postChargeCode = async (formData) => {
  //   try {
  //     // const response = await fetch(`https://digitallr-uat.flyjaclogistics.com/cost_modelling-be/charge/save`, {
  //     //   method: 'POST',
  //     //   headers: {
  //     //     'Content-Type': 'application/json',
  //     //     'Accept': 'application/json',
  //     //   },
  //     //   body: JSON.stringify(formData)
  //     // });


  //     const response = await fetchWithAuth(
  //       `/charge/save`,
  //       {
  //         method: 'POST',
  //         headers: {
  //           'Content-Type': 'application/json',
  //           'Accept': 'application/json',
  //         },
  //         body: JSON.stringify(formData)
  //       }
  //     );

  //     if (!response.ok) {
  //       const errorData = await response.json();
  //       throw new Error(errorData.message || `HTTP error! Status: ${response.status}`);
  //     }

  //     const result = await response.json();
  //     toast.success('Charge code created successfully!');
  //     fetchChargeCodes();
  //     return result;
  //   } catch (error) {
  //     console.error("Error creating charge code:", error);
  //     throw error;
  //   }
  // };

  const postChargeCode = async (formData) => {
    try {
      const response = await axiosInstance.post("/charge/save", formData, {
        headers: {
          Accept: "application/json",
        },
      });

      toast.success("Charge code created successfully!");
      setTimeout(() => {
        fetchChargeCodes();
      }, 800);

      return response.data;
    } catch (error) {
      console.error("Error creating charge code:", error);

      const errorMessage =
        error.response?.data?.message ||
        "An error occurred while creating charge code.";

      toast.error(errorMessage);
      throw error;
    }
  };


  // const putChargeCode = async (id, formData) => {
  //   try {
  //     const payload = {
  //       id: formData.id, // include id inside the body
  //       ...formData
  //     }
  //     // const response = await fetch(`https://digitallr-uat.flyjaclogistics.com/cost_modelling-be/charge/update`, {
  //     //   method: 'PUT',
  //     //   headers: {
  //     //     'Content-Type': 'application/json',
  //     //     'Accept': 'application/json',
  //     //   },
  //     //   body: JSON.stringify(payload)
  //     // });

  //     const response = await fetchWithAuth(
  //       `/charge/update`,
  //       {
  //         method: 'PUT',
  //         headers: {
  //           'Content-Type': 'application/json',
  //           'Accept': 'application/json',
  //         },
  //         body: JSON.stringify(payload)
  //       }
  //     );

  //     if (!response.ok) {
  //       const errorData = await response.json();
  //       throw new Error(errorData.message || `HTTP error! Status: ${response.status}`);
  //     }

  //     const result = await response.json();
  //     toast.success('Charge code updated successfully!');
  //     fetchChargeCodes();
  //     return result;
  //   } catch (error) {
  //     console.error("Error updating charge code:", error);
  //     throw error;
  //   }
  // };

  const putChargeCode = async (id, formData) => {
    try {
      const payload = {
        id,
        ...formData,
      };

      const response = await axiosInstance.put("/charge/update", payload, {
        headers: {
          Accept: "application/json",
        },
      });

      toast.success("Charge code updated successfully!");
      setTimeout(() => {
        fetchChargeCodes();
      }, 800);

      return response.data;
    } catch (error) {
      console.error("Error updating charge code:", error);

      const errorMessage =
        error.response?.data?.message ||
        "An error occurred while updating charge code.";

      toast.error(errorMessage);
      throw error;
    }
  };



  const saveChargeCode = async (formData) => {
    try {
      if (editData) {
        await putChargeCode(editData.id, formData);
      } else {
        await postChargeCode(formData);
      }

      setTimeout(() => {
        closePopup();
      }, 800);
    } catch (error) {
      console.error("Save operation failed:", {
        error: error.toString(),
        formData,
        isEdit: !!editData,
      });
      toast.error(`Operation failed: ${error.message}`);
    }
  };




  // Fetch single charge code for editing
  // const fetchChargeCodeForEdit = async (id) => {
  //   try {
  //     // const response = await fetch(`https://digitallr-uat.flyjaclogistics.com/cost_modelling-be/charge/edit/${id}`);

  //     const response = await fetchWithAuth(
  //       `/charge/edit/${id}`
  //     );

  //     if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);

  //     const data = await response.json();
  //     setEditData(data.charges);
  //     setIsPopupOpen(true);
  //   } catch (error) {
  //     console.error("Error fetching charge code:", error);
  //     toast.error(`Failed to load charge code for editing: ${error.message}`);
  //   }
  // };

  const fetchChargeCodeForEdit = async (id) => {
    try {
      const response = await axiosInstance.get(`/charge/edit/${id}`);

      const data = response.data;
      setEditData(data.charges);
      setIsPopupOpen(true);
    } catch (error) {
      console.error("Error fetching charge code:", error);

      const errorMessage =
        error.response?.data?.message || "Failed to load charge code for editing.";

      toast.error(errorMessage);
    }
  };




  // Delete charge code
  // const deleteChargeCode = async (id) => {
  //   const confirmDelete = window.confirm("Are you sure you want to delete this charge code?");
  //   if (!confirmDelete) return;

  //   try {
  //     // const response = await fetch(`https://digitallr-uat.flyjaclogistics.com/cost_modelling-be/charge/delete/${id}`, {
  //     //   method: 'DELETE'
  //     // });

  //     const response = await fetchWithAuth(`/charge/delete/${id}`, {
  //       method: 'DELETE',
  //     });

  //     if (response.ok) {
  //       toast.success("Charge code deleted successfully!");
  //       fetchChargeCodes(); // Refresh the list
  //     } else {
  //       const errorMessage = await response.text();
  //       toast.error(`Failed to delete charge code! ${errorMessage}`);
  //     }
  //   } catch (error) {
  //     console.error("Error:", error);
  //     toast.error("Something went wrong while deleting!");
  //   }
  // };

  const confirmDeleteChargeCode = async () => {
    if (!selectedChargeCodeId) return;

    try {
      await axiosInstance.delete(`/charge/delete/${selectedChargeCodeId}`);
      toast.success("Charge code deleted successfully!");
      fetchChargeCodes(); // Refresh the list
    } catch (error) {
      console.error("Error deleting charge code:", error);
      const errorMessage = error.response?.data?.message || "Something went wrong while deleting!";
      toast.error(errorMessage);
    }

    setConfirmDeleteOpen(false);
    setSelectedChargeCodeId(null);
  };

  const cancelDeleteChargeCode = () => {
    setConfirmDeleteOpen(false);
    setSelectedChargeCodeId(null);
  };


  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popupRef.current && !popupRef.current.contains(event.target)) {
        closePopup();
      }
    };
    if (isPopupOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isPopupOpen]);

  const handlePageClick = ({ selected }) => {
    setCurrentPage(selected);
    setSkip(selected * limit);
  };

  const handleLimitChange = (e) => {
    const newLimit = Number(e.target.value);
    setLimit(newLimit);
    setCurrentPage(0);
    setSkip(0);
  };

  const handleDateSelection = (date) => {
    console.log("Selected Date:", date);
  };

  const handleAddNewClick = () => {
    setEditData(null);
    setIsPopupOpen(true);
  };

  const closePopup = () => {
    setEditData(null);
    setIsPopupOpen(false);
  };

  const isAllSelected = selectedRows.length === tableData.length;
  const isAnySelected = selectedRows.length > 0;

  const handleSelectAll = () => {
    setSelectedRows(isAllSelected ? [] : tableData.map((row) => row.id));
  };

  const handleRowSelect = (id) => {
    setSelectedRows((prev) =>
      prev.includes(id) ? prev.filter((rowId) => rowId !== id) : [...prev, id]
    );
  };

  const handleEditClick = (id) => {
    fetchChargeCodeForEdit(id);
  };

  const handleDeleteClick = (id) => {
    setSelectedChargeCodeId(id);
    setConfirmDeleteOpen(true);
  };


  const handleUploadClick = () => {
    setShowUploadPopup(true);
  };

  const handleCloseUpload = () => {
    setShowUploadPopup(false);
    setSelectedFile(null);
    // setErrorData(null);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    setIsDragging(true);
  };

  const handleDragLeave = () => {
    setIsDragging(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setIsDragging(false);
    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
      setSelectedFile(e.dataTransfer.files[0]);
    }
  };

  const handleFileChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      setSelectedFile(e.target.files[0]);
    }
  };

  const handleChooseFile = () => {
    fileInputRef.current.click();
  };

  const handleTemplateDownload = async () => {
    try {
      const response = await axiosInstance.get('/charge/template_download', {
        responseType: 'blob',
      });

      const blob = new Blob([response.data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'charge_code_template.xlsx'); // Match backend name
      document.body.appendChild(link);
      link.click();
      link.remove();

      toast.success("Template downloaded successfully");
    } catch (error) {
      toast.error("Failed to download template");
      console.error("Template download error:", error);
    }
  };


  const handleImport = async () => {
    if (!selectedFile) {
      toast.warning("Please select a file first");
      return;
    }

    const formData = new FormData();
    formData.append('charge_code_upload', selectedFile);

    try {
      setLoading(true);
      setErrorData(null); // Reset

      const response = await axiosInstance.post('/charge/import', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      console.log("Upload success response:", response.data);
      if (response.data.success) {
        // toast.success("Charge Code imported successfully");
        // handleCloseUpload();
        // fetchChargeCodes();

        toast.success("Charge Code imported successfully");
        setTimeout(() => {
          handleCloseUpload();
          fetchChargeCodes();
        }, 1000)
      } else {
        toast.warning(`${response.data.message}`);
        setErrorData(response.data.error_data);
        handleCloseUpload();
      }
    } catch (error) {
      toast.error(`Import failed: ${error.message}`);
      console.error("Import error:", error);
    } finally {
      setLoading(false);
    }
  };



  const handleDownloadErrorReport = async () => {
    if (!errorData) return;

    try {
      // Send errorData directly as an object, no need to stringify it
      const response = await axiosInstance.post(
        '/charge/error_report',
        { data2: errorData },  // Send as an object
        { responseType: 'blob' }
      );

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'Error_Report.xlsx');
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      toast.error("Failed to download error report.");
      console.error("Error report download error:", error);
    }
  };

  const handleBulkDeleteClick = (ids) => {
    if (ids.length === 0) {
      toast.warning("Please select at least one charge code to delete.");
      return;
    }
    setBulkDeleteIds(ids);
    setBulkConfirmOpen(true);
  };


  const confirmBulkDeleteChargeCodes = async () => {
    if (bulkDeleteIds.length === 0) return;

    try {
      setLoading(true);
      await axiosInstance.delete('/charge/bulk_delete', {
        data: { ids: bulkDeleteIds }
      });

      toast.success(`${bulkDeleteIds.length} charge code(s) deleted successfully!`);
      fetchChargeCodes();
      setSelectedRows([]);
    } catch (error) {
      console.error("Error deleting charge codes:", error);
      const errorMessage = error.response?.data?.message || "Something went wrong while deleting!";
      toast.error(errorMessage);
    } finally {
      setLoading(false);
      setBulkConfirmOpen(false);
      setBulkDeleteIds([]);
    }
  };

  const cancelBulkDelete = () => {
    setBulkConfirmOpen(false);
    setBulkDeleteIds([]);
  };


  const handleSearch = async (term) => {
    setSearchTerm(term);
    setSkip(0);
    await fetchChargeCodes(term);
  };

  return (
    <>
      <Masters_header onSearch={handleSearch} />
      <div className="container">
        {errorData && (
          <div
            onClick={handleDownloadErrorReport}
            style={{
              display: 'flex',
              alignItems: 'center',
              backgroundColor: '#FEE2E2',
              color: '#B91C1C',
              padding: '12px 20px',
              borderRadius: '8px',
              fontWeight: '500',
              fontSize: '14px',
              marginTop: '10px',
              marginBottom: '10px',
              cursor: 'pointer',
              gap: '10px',
              width: '100%', // full width of container
              boxSizing: 'border-box',
              boxShadow: '0 1px 4px rgba(0,0,0,0.1)',
            }}
          >
            <FaExclamationCircle style={{ fontSize: '16px' }} />
            <span style={{ textDecoration: 'underline' }}>
              Click here to download the error report
            </span>
          </div>
        )}
        <div className="header">
          <div className="left-header">
            <h3>All Charge Codes : {total}</h3>
          </div>
          <div className="right-header">
            {/* {!isAnySelected ? (
              <>
                <DatePicker onDateChange={handleDateSelection} />

                <h4>Sort by :</h4>
                <div className="dropdown">
                  <select id="options" className="dropdown-select">
                    <option value="option1">Date Created</option>
                    <option value="option2">Option 2</option>
                    <option value="option3">Option 3</option>
                  </select>
                </div>
              </>
            ) : (
              <button 
                id="deleteBtn" 
                className="deleteBtn" 
                onClick={() => {
                  selectedRows.forEach(id => handleDeleteClick(id));
                  setSelectedRows([]);
                }}
              >
                Delete
              </button>
            )} */}


            {isAnySelected ? (
              <button
                id="deleteBtn"
                className="deleteBtn"
                style={{ margin: '0px' }}
                onClick={() => handleBulkDeleteClick(selectedRows)}
              >
                Delete
              </button>

            ) : (
              <>

                <AdditionalPermissionWrapper permissionKey="charge_code_upload" moduleId={ModuleId}>
                  <button className='jobs-filter-upload-btn' onClick={handleUploadClick} style={{ height: '35px', borderRadius: '6px' }}>Upload</button>
                </AdditionalPermissionWrapper>

                {showUploadPopup && (
                  <div style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'rgba(0, 0, 0, 0.5)',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    zIndex: 1000
                  }}>
                    <div style={{
                      backgroundColor: 'white',
                      padding: '24px',
                      borderRadius: '8px',
                      width: '600px',
                      maxWidth: '90%',
                      boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
                    }} ref={popupRef}>
                      <div style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        marginBottom: '10px'
                      }}>
                        <h2 style={{ fontSize: '18px', margin: 0 }}>Upload file</h2>
                        <button
                          onClick={handleCloseUpload}
                          style={{
                            background: 'transparent',
                            border: 'none',
                            fontSize: '24px',
                            cursor: 'pointer',
                            color: '#6B7280'
                          }}
                        >
                          ×
                        </button>
                      </div>

                      <div
                        style={{
                          border: '2px dashed',
                          borderColor: isDragging ? '#3B82F6' : '#D1D5DB',
                          backgroundColor: isDragging ? '#EFF6FF' : 'transparent',
                          borderRadius: '8px',
                          padding: '48px',
                          display: 'flex',
                          flexDirection: 'column',
                          alignItems: 'center',
                          justifyContent: 'center',
                          textAlign: 'center',
                          cursor: 'pointer',
                          marginBottom: '20px'
                        }}
                        onDragOver={handleDragOver}
                        onDragLeave={handleDragLeave}
                        onDrop={handleDrop}
                      >
                        <div style={{
                          width: '64px',
                          height: '50px',
                          color: '#9CA3AF',
                          fontSize: '48px'
                        }}>
                          <img style={{ height: '45px' }} src={plus_circle} alt='' />
                        </div>

                        <p style={{ marginBottom: '8px', fontSize: '14px' }}>
                          Drag and drop a file here or{' '}
                          <button
                            type="button"
                            onClick={handleChooseFile}
                            style={{
                              color: '#3B82F6',
                              background: 'none',
                              border: 'none',
                              textDecoration: 'underline',
                              cursor: 'pointer',
                              fontWeight: 'bold',
                              fontSize: '14px'
                            }}
                          >
                            Choose file
                          </button>
                        </p>

                        {selectedFile && (
                          <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            backgroundColor: '#F3F4F6',
                            padding: '8px 12px',
                            borderRadius: '8px',
                            marginTop: '16px',
                            width: '100%',
                            position: 'relative'
                          }}>
                            {/* File type icon */}
                            <div style={{
                              marginRight: '12px',
                              width: '24px',
                              height: '24px',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center'
                            }}>
                              {selectedFile.name.endsWith('.xlsx') || selectedFile.name.endsWith('.xls') ? (
                                <img src={excel_icon} alt="Excel" style={{ width: '24px', height: '24px' }} />
                              ) : selectedFile.name.endsWith('.csv') ? (
                                <img src="/csv-icon.png" alt="CSV" style={{ width: '24px', height: '24px' }} />
                              ) : (
                                <img src="/file-icon.png" alt="File" style={{ width: '24px', height: '24px' }} />
                              )}
                            </div>

                            {/* File info */}
                            <div style={{ flex: 1 }}>
                              <div style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center'
                              }}>
                                <span style={{ fontSize: '14px', fontWeight: '500' }}>
                                  {selectedFile.name}
                                </span>
                              </div>
                            </div>

                            {/* Remove button */}
                            <button
                              onClick={() => setSelectedFile(null)}
                              style={{
                                position: 'absolute',
                                top: '8px',
                                right: '8px',
                                background: '#EF4444',
                                color: 'white',
                                border: 'none',
                                borderRadius: '50%',
                                width: '20px',
                                height: '20px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                cursor: 'pointer',
                                fontSize: '12px'
                              }}
                            >
                              ×
                            </button>
                          </div>
                        )}

                        <input
                          type="file"
                          ref={fileInputRef}
                          onChange={handleFileChange}
                          style={{ display: "none" }}
                          accept=".xlsx, .xls, .csv"
                        />
                      </div>

                      <div style={{
                        display: 'flex',
                        justifyContent: 'space-between'
                      }}>
                        <button
                          onClick={handleTemplateDownload}
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px',
                            backgroundColor: 'transparent',
                            border: '1px solid #ccc',
                            padding: '8px 16px',
                            borderRadius: '16px',
                            cursor: 'pointer',
                            height: '35px'
                          }}
                        >
                          <img src={download_arrow} alt="Download" /> Template Download
                        </button>

                        <button
                          onClick={handleImport}
                          style={{
                            backgroundColor: '#2563EB',
                            color: '#fff',
                            padding: '8px 16px',
                            borderRadius: '16px',
                            height: '35px',
                            width: '100px',
                            border: 'none',
                            cursor: 'pointer',
                            opacity: !selectedFile || loading ? 0.7 : 1,
                            pointerEvents: !selectedFile || loading ? 'none' : 'auto'
                          }}
                        >
                          {loading ? 'Importing...' : 'Import'}
                        </button>
                      </div>
                    </div>
                  </div>
                )}

                <PermissionWrapper permissionKey="create_permission" moduleId={ModuleId}>
                  {!isAnySelected && (
                    <button id="addNewBtn" onClick={handleAddNewClick}>
                      Add New
                    </button>
                  )}
                </PermissionWrapper>
              </>
            )}
          </div>
        </div>

        <div style={{ overflowX: 'auto', whiteSpace: 'nowrap', scrollbarWidth: 'none', OverflowStyle: 'none', WebkitOverflowScrolling: 'touch', scrollBehavior: 'smooth' }}>

          <table>
            <thead>
              <tr>
                <th style={{ width: "1px" }}>
                  <input
                    type="checkbox"
                    checked={isAllSelected}
                    onChange={handleSelectAll}
                  />
                </th>
                <th>Code</th>
                <th>Name</th>
                <th>Charge Type</th>
                <th>Sap Code</th>
                <th>GL Code</th>
                <th>Category</th>
                <th className="">Modified Date</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {tableData.length > 0 ? (
                tableData.map((chargecode) => (
                  <tr key={chargecode.id}>
                    <td>
                      <input
                        type="checkbox"
                        checked={selectedRows.includes(chargecode.id)}
                        onChange={() => handleRowSelect(chargecode.id)}
                      />
                    </td>
                    <td>{chargecode.charge_code}</td>
                    <td>{chargecode.charge_name}</td>
                    <td>{chargecode.charge_type}</td>
                    <td>{chargecode.sap_code || '--:--'}</td>
                    <td>{chargecode.gl_code || '--:--'}</td>
                    <td>{chargecode.name}</td>
                    <td>{chargecode.modifieddate || '--:--'}</td>
                    <td>
                      <div className="actions">

                        <PermissionWrapper permissionKey="edit_permission" moduleId={ModuleId}>
                          <span
                            className="edit-icon"
                            style={{ cursor: 'pointer' }}
                            onClick={() => handleEditClick(chargecode.id)}
                          >
                            <img src={Vector} alt="Edit Icon" width="20" height="20" />
                          </span>
                        </PermissionWrapper>

                        <PermissionWrapper permissionKey="delete_permission" moduleId={ModuleId}>
                          <span
                            className="delete-icon"
                            style={{ cursor: 'pointer' }}
                            onClick={() => handleDeleteClick(chargecode.id)}
                          >
                            <img src={Delete} alt="Delete Icon" width="40" height="40" />
                          </span>
                        </PermissionWrapper>


                      </div>
                    </td>
                  </tr>
                ))) : (
                <tr>
                  {searchTerm && tableData.length === 0 && (
                    <td colSpan="7" style={{ textAlign: 'center', padding: '20px', fontSize: '14px', color: '#666' }}>
                      No ChargeCode found matching "{searchTerm}"
                    </td>
                  )}
                </tr>
              )}
            </tbody>
          </table>
        </div>

        <div className="pagination-container d-flex align-items-center justify-content-between mt-3">
          <div className="Limit-Dropdown">
            <label htmlFor="limit" className="fw-semibold">Items per page:</label>
            <select
              id="limit"
              value={limit}
              onChange={handleLimitChange}
              className="form-select d-inline w-auto"
            >
              <option value="5">5</option>
              <option value="10">10</option>
              <option value="25">25</option>
              <option value="50">50</option>
            </select>
          </div>

          <div className="d-flex align-items-center gap-4">
            <ReactPaginate
              previousLabel={<span style={{ userSelect: "none" }}>Previous</span>}
              nextLabel={<span style={{ userSelect: "none" }}>Next</span>}
              pageCount={totalPages > 0 ? totalPages : 1}
              onPageChange={handlePageClick}
              containerClassName={"pagination d-flex"}
              activeClassName={"active"}
              marginPagesDisplayed={1}
              pageRangeDisplayed={3}
              forcePage={currentPage}
            />
          </div>
        </div>
      </div>
      {isPopupOpen && (
        <div className="popup-overlay">
          <div className="popup-content" ref={popupRef}>
            <ChargeCode_popup
              closePopup={closePopup}
              onSubmit={saveChargeCode}
              editData={editData}
            />
          </div>
        </div>
      )}
      <CommonFooter />
      <ToastContainer position="top-right" autoClose={2000} hideProgressBar={false} />
      <ConfirmDialog
        open={confirmDeleteOpen}
        title="Delete Charge Code"
        message="Are you sure you want to delete this charge code?"
        confirmText="Delete"
        cancelText="Cancel"
        onConfirm={confirmDeleteChargeCode}
        onCancel={cancelDeleteChargeCode}
      />
      <ConfirmDialog
        open={bulkConfirmOpen}
        title="Bulk Delete"
        message={`Are you sure you want to delete ${bulkDeleteIds.length} charge code(s)?`}
        confirmText="Delete"
        cancelText="Cancel"
        onConfirm={confirmBulkDeleteChargeCodes}
        onCancel={cancelBulkDelete}
      />
    </>

  )
}

export default ChargeCode;             